import styles from "./style.postcss";
import React from "react";
import classnames from "classnames";
import ReactGA from "react-ga4";
import is from "is_js";
import { List } from "immutable";
import { Icon, testClass } from "omni-common-ui";
import PropTypes from "prop-types";

const MARKING = "edit";

const ViewSwitch = (props) => {
  const { params, routes, redirect, buildRoute, toggle, viewMode } = props;
  if (!shouldShow()) {
    return null;
  }

  const currentRoute = routes[routes.length - 1];
  const isMarking = params && params.mode === MARKING;
  const prefix = isMarking ? "../" : "";
  const isCourseView = currentRoute.view === "course" || viewMode === "course";

  if (!props.viewMode) {
    initSessionSwitchMode(currentRoute.view);
  }
  if (!viewMode) return null;

  const onContainerClick = isCourseView
    ? buildOnClick(`${prefix}../day`)
    : buildOnClick(`${prefix}../course`);

  const sessionClasses = classnames(
    styles.ViewSwitch_item,
    styles.__session,
    testClass("view-switch-session"),
    { [styles.__selected]: !isCourseView },
  );
  const courseClasses = classnames(
    styles.ViewSwitch_item,
    styles.__course,
    testClass("view-switch-course"),
    { [styles.__selected]: isCourseView },
  );

  return (
    <div className={styles.ViewSwitch} onClick={onContainerClick}>
      <div className={sessionClasses}>
        <Icon id="toggle-session" className={styles.ViewSwitch_icon} />
      </div>
      <div className={courseClasses}>
        <Icon id="toggle-course" className={styles.ViewSwitch_icon} />
      </div>
    </div>
  );

  function buildOnClick(redirectUrl) {
    return () => {
      ReactGA.event({
        category: "Navigation",
        action: "Clicked session/course switch",
      });

      toggle();
      redirect(buildRoute(redirectUrl));
    };
  }

  function shouldShow() {
    const config = new List(routes).findLast(
      ({ showSessionCourseSwitch }) =>
        is.function(showSessionCourseSwitch) ||
        is.boolean(showSessionCourseSwitch),
    );
    if (!config) {
      return false;
    }

    if (is.function(config.showSessionCourseSwitch)) {
      return config.showSessionCourseSwitch(props);
    }

    return config.showSessionCourseSwitch === true;
  }

  function initSessionSwitchMode(mode = "day") {
    props.toggle(mode);
  }
};

ViewSwitch.propTypes = {
  params: PropTypes.shape({ mode: PropTypes.string }),
  routes: PropTypes.arrayOf(PropTypes.shape({ view: PropTypes.string })),
  redirect: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  viewMode: PropTypes.string,
};

export default ViewSwitch;



// WEBPACK FOOTER //
// ./containers/Group/GroupInfoBar/SessionCourseSwitch/index.jsx